// vjs-player.component.ts
import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import Player from 'video.js/dist/types/player';
import videojs from 'video.js';


@Component({
    selector: 'app-vjs-player',
    template: `
    <video #target class="video-js" [attr.aria-label]="altText" controls preload="auto"></video>
  `,
    styleUrls: [
        './videojsplayer.component.css'
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class VjsPlayerComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('target', { static: true }) target: ElementRef;
  // see options: https://github.com/videojs/video.js/blob/maintutorial-options.html
  @Input() options: {
    fluid?: boolean,
    aspectRatio: string,
    autoplay: boolean,
    poster: string,
    sources: {
      src: string,
      type: string,
    }[],
  };
  @Input() altText: string = "";
  player: Player;

  constructor(
    private elementRef: ElementRef,
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.player && changes['options']) {
      this.player.src(this.options.sources);
      this.player.poster(this.options.poster);
      this.player.autoplay(this.options.autoplay);
    }
  }

  ngOnInit() {
    this.player = videojs(this.target.nativeElement, this.options, function onPlayerReady() {
      console.log('onPlayerReady', this);
    });
  }

  ngOnDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }
}
